import objectPath from 'object-path'

export const onRuleCloseModal = (designContext = {}) => {
  let {
    jsonForm = {},
    designerPropsData,
    setDesignerPropsData,
    elementAction = {},
    setElementAction,
    isUiChanged = {},
    setIsUiChanged,
    setOpenModal,
  } = designContext
  let modalCode = objectPath.get(jsonForm, 'designerPropsData.modal')

  designerPropsData =
    designerPropsData || objectPath.get(jsonForm, 'designerPropsData') || {}
  objectPath.set(designerPropsData, 'modal', null)
  if (setDesignerPropsData) setDesignerPropsData(designerPropsData)

  if (modalCode) {
    objectPath.set(elementAction, ['openModal', modalCode], false)
  }
  if (setElementAction) setElementAction(elementAction)

  objectPath.del(isUiChanged, 'modal')
  objectPath.del(isUiChanged, 'isModalRender')
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  if (setOpenModal) setOpenModal(null)

  return { isCloseModal: true }
}
